import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Stack } from '@mui/material';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getRetentionDetails } from '../../../../redux/features/dashboardSlice';
import { COMPANY } from './utils/employeeDetailsPageHelper';
import { RetentionTableHeader } from './utils/retentionDetailsPageHelper';
import { useSearchParams } from 'react-router-dom';

function RetentionDetails() {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
    // status: { id: -1, value: '' },
    // company: { id: -1, value: '' },
  });

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const retentionDetailsData = useSelector((state) => state.dashboard.retentionDetails.data);
  const retentionDetailsLoading = useSelector((state) => state.dashboard.retentionDetails.loading);
  const retentionDetailsMeta = useSelector((state) => state.dashboard.retentionDetails.meta);

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      search: tableState?.search,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      sortBy: tableState.sort.field || 'retentionDate',
      sortDirection: tableState.sort.direction || 'desc',
      dept: filters?.company?.id === -1 ? 'all' : filters?.company?.id,
    };
    dispatch(getRetentionDetails(params));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);

  const formattedRows = Array.isArray(retentionDetailsData)
    ? retentionDetailsData.flatMap((student) =>
        (student.retentionEvents || []).map((event, index) => ({
          id: `${student.admn_no}-${index}`,
          admn_no: student.admn_no,
          studentName: student.studentName,
          isCurrentlyPursuing: student.isCurrentlyPursuing,
          fromCourse: event.fromCourse,
          toCourse: event.toCourse,
          retentionDate: event.retentionDate,
          gapDays: event.gapDays,
          type: event.type,
          revenue: event.revenue,
        })),
      )
    : [];

  useEffect(() => {
    if (queryFromDate) {
      filterHelper(dayjs(queryFromDate).format('YYYY-MM-DD'), 'fromDate');
    }

    if (queryToDate) {
      filterHelper(dayjs(queryToDate).format('YYYY-MM-DD'), 'toDate');
    }
  }, [queryFromDate, queryToDate]);
  return (
    <GlobalWrapper title={'Retention Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
        {/* <GlobalSelectFieldWithoutFormik
          sx={{ width: { xs: '100%', sm: 200 } }}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Company'}
          data={COMPANY}
          setDirectChange={(v) => filterHelper(v, 'company')}
          selectedDetails={filters['company']}
        /> */}
      </Stack>

      <GlobalTable
        rowUniqueId="id"
        headers={RetentionTableHeader}
        rows={formattedRows}
        loading={retentionDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={retentionDetailsMeta}
      />
    </GlobalWrapper>
  );
}

export default RetentionDetails;
